module.exports = __webpack_public_path__ + "static/driver-on-the-road-077d204497a9f31ff5b477646ab6456e.jpg";